// @need-translate
import {ApiStatusCodeVo} from '../common/shared/api/nicolas/vo/enums/ApiStatusCodeVo.enum';
import {TextTKey} from '../common/type';
import {AgeGrade} from '../graphql/generated/types';
import {SelfCertRequestType} from './SelfCertRequestType.enum';

export const NEED_PARENT_SELF_CERT_AGE = 14;

export const SELF_CERT_PROCESS_ENC_KEY = 'UAPEK';
export const SELF_CERT_PROCESS_RETURN_VALUE_KEY = 'R';

export const AUTH_TYPE_TO_LOG_TITLE: {
  [key in SelfCertRequestType]?: string;
} = {
  [SelfCertRequestType.Parent]: '보호자',
  [SelfCertRequestType.Age15]: '15세',
  [SelfCertRequestType.Age19]: '19세',
  [SelfCertRequestType.AutoCharging]: '자동충전',
  [SelfCertRequestType.OverCharging]: '월5만원초과',
  [SelfCertRequestType.TvPoint]: 'TV포인트',
  [SelfCertRequestType.CreditRefund]: '환불요청',
  [SelfCertRequestType.Normal]: '본인인증',
};

export const SELF_CERT_REQUIREMENTS_ERROR_MESSAGE = '필요한 정보가 없습니다.';
export const SELF_CERT_UNKNOWN_ERROR_MESSAGE =
  '알 수 없는 에러가 발생하였습니다.';
export const SELF_CERT_API_ERROR_MESSAGE =
  '잠시 후 다시 시도해주세요.\n일시적인 문제로 본인인증을 할 수 없습니다.\n지속적으로 문제가 발생되면 고객센터에 문의해주세요.';
export const SELF_CERT_FAIL_ERROR_MESSAGE =
  '본인인증에 실패했습니다.\n확인 후 다시 시도해주세요.';
export const PARENT_SELF_CERT_FAIL_ERROR_MESSAGE =
  '보호자 인증에 실패했습니다.\n확인 후 다시 시도해주세요.';

export const SELF_CERT_ERROR_CODE_TO_MESSAGE: {[index: number]: TextTKey} = {
  [ApiStatusCodeVo.AuthInfoAgeDifferenceFail]: {
    text: '보호자(법정대리인)와의 나이차가 만 18세 이상이어야 합니다.',
    textTKey: 'verify_error_agegap18',
  },
  [ApiStatusCodeVo.Under14AgeAuthCompletedWithoutLegalAgentAuth]: {
    text: '아동 인증 정보가 유효하지 않습니다.',
    textTKey: 'api_user_invalid_child_auth_info',
  },
  [ApiStatusCodeVo.AuthInfoDifferentPrevCi]: {
    text: '기존 본인인증 정보와 일치하지 않아 본인인증이 불가합니다.\n문의사항은 [더보기 > 고객센터 > 문의하기]로 접수해주세요.',
    textTKey: 'verify_error_ci_mismatch_code',
  },
};

/**
 * 본인 인증 타입과 만 나이 제한 최소값을 매핑한 값입니다.
 * 타입의 만 나이 제한 최소값이 없으면 undefined로 매핑됩니다.
 */
export const SELF_CERT_REQUEST_TYPE_TO_AGE_LIMIT_MAP: {
  [key in SelfCertRequestType]: number | undefined;
} = {
  [SelfCertRequestType.Unknown]: undefined,
  [SelfCertRequestType.UnderAge14]: undefined,
  [SelfCertRequestType.Age15]: 15,
  [SelfCertRequestType.Age19]: 19,
  [SelfCertRequestType.OverCharging]: undefined,
  [SelfCertRequestType.AutoCharging]: undefined,
  [SelfCertRequestType.TvPoint]: undefined,
  [SelfCertRequestType.TvPointTerms]: undefined,
  [SelfCertRequestType.Parent]: undefined,
  [SelfCertRequestType.Normal]: undefined,
  [SelfCertRequestType.CreditRefund]: undefined,
};

// @TODO: 번역키에 개행 처리가 미비하여 개행 추가된 번역 값을 새로 받아야 합니다.
export const SELF_CERT_REQUEST_TO_TEXT_MAP: {
  [type in SelfCertRequestType]: {main: TextTKey; desc?: TextTKey};
} = {
  [SelfCertRequestType.Unknown]: {
    main: {
      text: '(내용을 보여주지 않는 타입입니다.)',
      // @ts-expect-error
      textTKey: '',
    },
  },
  [SelfCertRequestType.UnderAge14]: {
    main: {
      text: '만 14세 미만(이하 아동)의 개인정보 수집 및 이용 동의를 위해 보호자(법정대리인) 확인이 필요합니다.',
      textTKey: 'verify_terms_parents_text_title',
    },
  },
  [SelfCertRequestType.Age15]: {
    main: {
      text: '만 15세 이상만 이용 가능한 서비스로<br/>본인인증이 필요합니다.',
      textTKey: 'verify_terms_15age_text_title',
    },
  },
  [SelfCertRequestType.Age19]: {
    main: {
      text: '이 정보내용은 청소년 유해매체물로서<br/>정보통신망 이용촉진 및 정보보호 등에 관한<br/>법률 및 청소년 보호법에 따라<br/>19세 미만의 청소년이 이용할 수 없습니다.',
      textTKey: 'verify_terms_19age_text_title',
    },
    desc: {
      text: '청소년보호법 제 16조 및 여성가족부 청소년<br/>보호법 관계 법령에 따라 연 1회 본인인증이 필요합니다.',
      textTKey: 'verify_terms_19age_explanation',
    },
  },
  [SelfCertRequestType.OverCharging]: {
    main: {
      text: '월 5만원 초과 충전 시<br/>본인 확인이 필요합니다.',
      textTKey: 'verify_terms_5money_text_title',
    },
  },
  [SelfCertRequestType.AutoCharging]: {
    main: {
      text: '자동 충전 등록 시 최초 1회<br/>본인 확인이 필요합니다.',
      textTKey: 'verify_terms_autorecharge_text_title',
    },
  },
  [SelfCertRequestType.Parent]: {
    main: {
      text: '만 14세 미만(이하 아동)의 개인정보<br/>수집 및 이용 동의를 위해 보호자(법정대리인) 확인이 필요합니다.',
      textTKey: 'verify_terms_parents_text_title',
    },
  },
  [SelfCertRequestType.TvPoint]: {
    main: {
      text: 'TV포인트 조회 및 캐시 충전 시<br/>최초 1회 본인 확인이 필요합니다.',
      textTKey: 'verify_terms_tv_text_title',
    },
  },
  [SelfCertRequestType.TvPointTerms]: {
    main: {
      text: 'TV포인트 조회 및 TV포인트로<br/>캐시 충전을 위해<br/>아래 약관에 동의해주세요.',
      textTKey: 'verify_service_terms_tv_text_title',
    },
    desc: {
      text: '서비스 이용 시 최초 1회 제3자 정보제공 동의를 받습니다.',
      textTKey: 'verify_terms_tv_text_detail',
    },
  },
  [SelfCertRequestType.CreditRefund]: {
    main: {
      text: '환불 요청시 최초 1회<br/>본인 확인이 필요합니다.',
      textTKey: 'verify_terms_refund_text_title',
    },
  },
  [SelfCertRequestType.Normal]: {
    main: {
      text: '계속 진행하려면 본인확인이 필요합니다.',
      textTKey: 'verify_required_title',
    },
  },
};

export const AGE_GRADE_TO_SELF_CERT_REQUEST_TYPE_MAP = {
  [AgeGrade.Nineteen]: SelfCertRequestType.Age19,
  // 19세 이상 작품일 경우에만 본인인증을 시도합니다. 아래 값은 타입처리를 위해 추가한 값입니다. 실제로 사용되지 않습니다.
  [AgeGrade.All]: SelfCertRequestType.Unknown,
  [AgeGrade.Fifteen]: SelfCertRequestType.Unknown,
  [AgeGrade.Eighteen]: SelfCertRequestType.Unknown,
};
